import { animate, style, transition, trigger } from '@angular/animations';

export const slideInOut = trigger('slideInOut', [
  transition(':enter', [ style({ height: 0, opacity: 0 }), animate(50) ]),
  transition(':leave', [ animate(100, style({ height: 0, opacity: 0 })) ])
]);
